module.exports = __webpack_public_path__ + "img/1440.96297ea6.jpg";